










































import { IWikiCategory } from "@/@types/wiki/wiki-object";
import { Component, Prop, Inject, Vue } from "vue-property-decorator";

import BSwitch from "@/components/app/switchs/b-switch.vue";

@Component({ components: { BSwitch } })
export default class WikiCategoryList extends Vue {
  @Inject({ from: "categoryFolder", default: "" }) readonly folder!: string;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<IWikiCategory>;
}
